import { render } from "./AppDownloadGuideView.vue?vue&type=template&id=1b384f31"
import script from "./AppDownloadGuideView.vue?vue&type=script&lang=js"
export * from "./AppDownloadGuideView.vue?vue&type=script&lang=js"

import "./AppDownloadGuideView.vue?vue&type=style&index=0&id=1b384f31&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__